import React from 'react'
import { SelectedDepartmentField } from 'support/fields'
import NormManagerFieldsForItems from 'pages/app/inventory/norms/NormManagerFieldsForItems'

export default function NormManagerFields () {
  return (
    <>
      <SelectedDepartmentField />
      <NormManagerFieldsForItems />
    </>
  )
}
